import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import UploadCard from '../../../components/uploadDocument/UploadCard';

const useStyles = makeStyles((theme: any) => ({
  textArea: {
    boxSizing: 'inherit',
    minWidth: '100%',
    maxWidth: 'inherit',
    fontSize: 'large',
    height: '120px',
    resize: 'none',
    backgroundColor: theme.palette.brand.greyLight,
    borderRadius: '10px',
  },
}));

export default function UploadFileSubmit({ message, setMessage, ids, setIds }) {
  const classes = useStyles();
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);

  const onChange = (e) => {
    setMessage(e.target.value);
  };

  return (
    <>
      <textarea
        onChange={onChange}
        placeholder="Required: Tell us why you're making this request."
        value={message}
        name="message"
        id="message"
        className={classes.textArea}
      />
      <UploadCard
        optionalDoc={true}
        files={files}
        setFiles={setFiles}
        setIds={setIds}
        ids={ids}
        loading={loading}
        setLoading={setLoading}
        changes={null}
        setChangedRequestInfo={null}
      />
    </>
  );
}
